export const appendUniqueIds = (currentIds: string[], idsToAdd: string[]): string[] => {
  const nextIds = [...currentIds]

  for (const id of idsToAdd) {
    if (!nextIds.includes(id)) {
      nextIds.push(id)
    }
  }

  return nextIds.length === currentIds.length ? currentIds : nextIds
}
